angular.module('impactx.scheduler').controller('OrderStatVariableListCtrl', OrderStatVariableListCtrl);

function OrderStatVariableListCtrl() {
    var self = this;

    self.buttonDefinition = [];

    self.meta = {
        rowTemplate: 'modules/statistic/templates/orderstatvariablelist.row.tmpl.html',
        isSelectAble: false,
        ctrl: this,
        endpoint: '/statistic/orderstatvariablelist',
        id: "orderstatvariablelist",
        buttonDefinition: self.buttonDefinition,
        valuesInteger: [
            {
                name: 'IS_RESELLER_SLAVE',
                value: 2097152
            },
            {
                name: 'IS_RESELLER_MASTER',
                value: 1048576
            }
        ],
        noAutoRefresh: true
    };

    self.getMeta = function () {
        return self.meta;
    };
}